import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  drawerVisible: true,
  currentDrawerWidth: 240,
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    setDrawerVisible: (state, action) => {
      state.drawerVisible = Boolean(action.payload);
    },
    toggleDrawerVisible: (state) => {
      state.drawerVisible = !state.drawerVisible;
    },
    setCurrentDrawerWidth: (state, action) => {
      state.currentDrawerWidth = action.payload;
    },
  },
});

export const { setDrawerVisible, toggleDrawerVisible, setCurrentDrawerWidth } = drawerSlice.actions;
export default drawerSlice.reducer;
